import firebase from '../Firebase.js';
const db = firebase.firestore();
const collection = db.collection("sessionEvents");

class SessionEvent {
  constructor({
    sessionId,
    userId,
    type,
  }) {
    if (!userId || !sessionId || !type) {
      throw new Error("required parameters not met");
    }

    this.userId = userId;
    this.sessionId = sessionId;
    this.type = type;
  }

  async emit({
    name,
    content,
    completionId,
  }) {
    if (!name) {
      throw new Error("name is required");
    }

    await collection.add({
      sessionId: this.sessionId,
      userId: this.userId,
      type: this.type,
      name: name,
      createdAt: new Date(),
      content: content || null,
      completionId: completionId || null,
    });
  }

}


export default SessionEvent;
